import { AxiosError } from 'axios';
import { UseQueryOptions, useQuery } from 'react-query';
import { client } from '../util/client';
import { GetInvitationResponse } from '@aldebaran/common/types/api';

export const useClaimInvitation = (
  slug: string,
  options: UseQueryOptions<GetInvitationResponse, AxiosError> = {},
) => {
  return useQuery<GetInvitationResponse, AxiosError>(
    ['invitation', 'claim', slug],
    async () =>
      client(`/invitation/claim/${slug}`).then((response) => response?.data),
    {
      enabled: !!slug,
      onSuccess: async (response) => {
        options.onSuccess?.(response);
      },
      retry: false,
    },
  );
};
